<template>
  <div v-cloak id="test" :class="$isFlag ? 'mainH5' : 'mainWeb'">
    <!-- 顶部导航 -->
    <div v-if="!$isFlag" class="header top">
      <div class="con-wrap" :style="!isFlag ? 'padding: 0 23%;height:1.6rem' : ''">
        <a
          class="logo"
          href="//www.leiting.com/mobile/index.html"
        >雷霆游戏 <img
          src="~assets/images/accountCenter/logo.png"
          alt=""
        ></a>
        <div class="title">
          <p
            v-for="(item, index) in [
              '官网首页',
              '账号自助管理',
              '账号中心',
              '账号注册',
            ]"
            :key="index"
            :class="index === currentIndex ? 'active' : 'hover'"
            @click="titleClick(index)"
          >
            <span>{{ item }}</span>
          </p>
        </div>
        <div v-if="this.$store.state.authLogin.isLogin == '1'" class="logout">
          <p style="float: left; margin-right: 0.2rem">
            {{ this.$store.state.authLogin.userInfo || "XXX" }}
          </p>
          <p @click="logout">退出</p>
        </div>
      </div>
    </div>
    <div
      class="entrance-box"
      :style="
        !$isFlag
          ? 'background: #f5f7fb;'
          : 'background: #f5f7fb;'
      "
    >
      <div v-if="!isFlag">
        <img
          v-if="!isSelf"
          src="~assets/images/accountCenter/banner@2x.png"
          alt=""
          style="width: 100%; height: 5.4rem"
        >
        <img
          v-else
          src="~assets/images/accountCenter/1090.png"
          alt=""
          style="width: 100%; height: 5.4rem"
        >
      </div>

      <div class="content">
        <img
          class="leitingImg"
          src="~assets/images/accountCenter/245@2x.png"
          alt=""
          srcset=""
        >
        <div>
          <router-view />
        </div>
      </div>
    </div>
    <!-- 底部版权 -->
    <div
      id="LT_footer"
      data-key="gm1"
      data-tongji="gm"
      data-color="light"
      style="overflow: auto"
    />
  </div>
</template>

<script>
import * as api from '@/api/account-center-manage/accountInfo'
export default {
  // eslint-disable-next-line
  name: "index",
  components: {},
  data() {
    return {
      mHeight: null,
      http: window.location.href,
      isFlag: true, // 判断
      isSelf: true,
      currentIndex: 1,
      showTagList: []
    }
  },
  computed: {},
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log(val, 'aaaaaaaa')
        this.judge(val.path)
      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.judge(this.$route.path)
  },
  mounted() {
    this.isMobile()
    this.mHeight = window.innerHeight
  },
  methods: {
    judge(path) {
      if (path.includes('accountSelf') || path == '/accountCenter/index') {
        this.isSelf = true
        this.currentIndex = 1
      } else if (path == '/accountCenter/register') {
        this.isSelf = false
        this.currentIndex = 3
      } else {
        this.isSelf = false
        this.currentIndex = 2
      }
    },
    top() {
      window.LTFooter.init()
    },
    logout() {
      this.$pubConfirm('确定要退出吗？', () => {
        api.logout().then((res) => {
          if (res.status == 0) {
            this.$ssd.track('leiting_accountcenter_loggot')
            // 未登录
            this.$store.dispatch('authLogin/saveIslogin', '0')
            setTimeout(() => {
              window.ltlAccount.logout()
            })
            // this.$router.go(0)
          }
        })
      })
    },
    // 类型追加
    menu() {
      const t = document.getElementById('menu_btn')
      const d = document.getElementById('menu_modal')
      if (t.classList.contains('active')) {
        t.classList.remove('active')
        d.classList.remove('active')
      } else {
        t.classList.add('active')
        d.classList.add('active')
      }
    },
    titleClick(index) {
      this.currentIndex = index
      if (index === 0) {
        window.open('https://www.leiting.com/index.html')
      }
      if (index === 1) {
        this.$router.push('/accountCenter/index')
        this.$ssd.track('leiting_accountmanage')
      }
      if (index === 2) {
        this.$router.push('/accountCenter/accountList/accountInfo')
        this.$ssd.track('leiting_accountcenter')
      }
      if (index === 3) {
        this.$router.push('/accountCenter/register')
        this.$ssd.track('leiting_register')
      }
    },
    isMobile() {
      this.isFlag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      this.top()
    }
  }
}
</script>
<style lang="stylus">
@import '~assets/css/reset.styl';
</style>
<style lang="stylus" scoped>
// web
.mainWeb {
  .con-wrap .logo {
    width: auto;
    height: auto;

    img {
      width: auto;
      height: auto;
    }
  }

  .logout {
    color: #606DE2;
    font-size: 0.32rem;
    width: 3rem;
  }

  .content {
    padding: 0 20% 0;
    min-height: 9rem;
    position: relative;

    .leitingImg {
      width: 6.52rem;
      position: absolute;
      bottom: -2rem;
      right: 1.2rem;
    }
  }
}

.mainH5{
  .content {
    position: relative;
    min-height: 80vh;
    overflow: auto;
    overflow-x: hidden;
    margin-top: 1.2rem;
    // z-index 999

    .leitingImg {
      width: 5.23rem;
      position: absolute;
      bottom: 0;
      right: -1.2rem;
      z-index 0
    }
  }
}

.header .menu-wrap .list .item {
  min-height: 1.3rem;
  flex: none;
}

.active {
  border-bottom: 3px #606de2 solid;
  font-size: 0.4rem !important;
  color: black !important;
  font-weight: bold;
}

.title {
  position: absolute;
  width: 11rem;
  height: 100%;
  left: 37%;
  display: flex;

  p {
    flex: 1;
    color: #5d5d5d;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.36rem;
    cursor: pointer;
  }

  .hover {
    &:hover {
      color: black;
    }
  }
}
</style>
